import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "prod",
    aws_cognito_region: "eu-west-1",
    aws_cognito_identity_pool_id: "eu-west-1:cfbbfa4d-72da-43d8-8bdd-a32c0d6c46ca",
    aws_user_pools_id: "eu-west-1_A3z64tTcs",
    aws_user_pools_web_client_id: "2u9g20rq1185u68ri7esuur22c",
    Auth: {
      identityPoolId: "eu-west-1:cfbbfa4d-72da-43d8-8bdd-a32c0d6c46ca",
      region: "eu-west-1",
      userPoolId: "eu-west-1_A3z64tTcs",
      userPoolWebClientId: "2u9g20rq1185u68ri7esuur22c",
    },
    oauth: {
      domain: "whs-safer-prod-eu.auth.eu-west-1.amazoncognito.com",
      redirectSignIn: "https://prod.eu.safer.whs.amazon.dev",
      redirectSignOut: "https://prod.eu.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
